import React, { useEffect, useState, useRef } from 'react';
import close_button from '../../../assets/close_button.png';
import PmModuleStyle from '../styles/pm.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);
//require('highcharts/modules/mouse-wheel-zoom.js')(Highcharts);

const TasktimeGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, seriesStatus, setSeriesStatus, attempt, getTaskDataForGraph, simObjCopy,summaryReports}) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [RevenueData, setRevenueData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [TaskTimeData, setTaskTimeData] = useState({ "EXPECTED": [], "ACTUAL": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [TasktimeGraphLabel, setTasktimeGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const prevDataRef = useRef();
  const [tasksInfo, setTasksInfo] = useState([]);


  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }

  const setGraphData = () => {
    if (chart != undefined) {
      let TaskExpectedTime;
      let TaskActualTime;
      (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0]?.update({ min: 0, max: undefined });
      //TaskExpectedTime
      // if (simObj && simObj.graphdata && typeof simObj.graphdata.tasks === 'object') {
      //   TaskExpectedTime = simObj?.graphdata?.tasks;
      //   TaskExpectedTime = (TaskExpectedTime != undefined ? TaskExpectedTime : []).map((data) => {
      //     return {
      //       x: data.taskId,
      //       y: Math.floor(data.actualTime), //here used actualTime instead of elapsedTime asper DB
      //       currentState: data.currentState
      //     }
      //   });
      // }
      // setTaskTimeData(prevData => ({
      //   ...prevData,
      //   EXPECTED: TaskExpectedTime,
      // }));
      // if (TaskExpectedTime?.length != (chart?.series && Array.isArray(chart.series) && chart?.series[0]?.data?.length)) {
      //   chart?.series && chart?.series[0]?.setData(TaskExpectedTime?.map((it) => it.y));
      // }

      //TaskActualTime
      if (simObj && simObj?.graphdata && typeof simObj?.graphdata?.tasks === 'object') {
        TaskActualTime = simObj?.graphdata?.tasks;
        TaskActualTime = (TaskActualTime != undefined ? TaskActualTime : []).map((data) => {
          return {
            x: data.taskId,
            y: Math.floor(data.elapsedTime), //here used elapsedTime instead of actualTime asper DB
            z: Math.floor(data.actualTime), //here used actualTime instead of actualTime asper DB
            
            currentState: data.currentState
          }
        });
      }
      setTaskTimeData(prevData => ({
        ...prevData,
        ACTUAL: TaskActualTime,
      }));
      //if (true) { //TaskActualTime?.length == (chart?.series && Array.isArray(chart.series) && chart?.series[1]?.data?.length)
      const seriesData1 = TaskActualTime?.map((it) => { return { y: it.y, currentState: it.currentState } })
      let seriesData0= []
      if(!isResult && simObjCopy?.actions?.projectPlanOptions && typeof simObjCopy?.actions?.projectPlanOptions === 'object' ){
         seriesData0 = Object.values(getTaskDataForGraph(simObjCopy?.actions?.projectPlanOptions))
      }
      else if(isResult && summaryReports?.projectPlanOptions && typeof summaryReports?.projectPlanOptions == 'object'){
        seriesData0 = Object.values(getTaskDataForGraph(summaryReports?.projectPlanOptions))
      }
      // else{
      //    seriesData0 = TaskActualTime?.map((it) => { return { y: it.z } })
      // }
      setSeriesStatus(seriesData1);
      chart?.series && chart?.series[1]?.setData(seriesData1);
      chart?.series && chart?.series[0]?.setData(seriesData0);
      // }
      chart?.xAxis && chart?.xAxis[0]?.setCategories(TaskActualTime?.map((it) => it.x));

    }
    (simObj?.graphdata != undefined && simObj?.graphdata?.length == 0) && (chart && chart?.yAxis && chart?.yAxis[0]) && chart?.yAxis[0].update({ min: 1, max: 30 })
  }
  
  function applyAccessibility(chart) {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
        svg.setAttribute('role', 'img');

        svg.setAttribute('aria-label', 'chart showing expected and actual task durations for tasks A to Z.');

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent = "This chart compares the expected and actual durations for tasks labeled A through Z. The orange diagonal-striped bars indicate the expected task time, while the blue diagonal-striped bars show the actual task time in days.";
        svg.insertBefore(desc, svg.firstChild);
        },0);
      }
    }
  }

  graphSettings = {
    plotOptions: {
      series: {
        //stickyTracking: false,
        marker: {
          enabled: true,
        },
        //pointPlacement: "on",
        dataLabels: {
          enabled: false,
        }
      },
      states: {
        inactive: {
          enabled: false
          //opacity:1
        },
      },
    },
    chart: {
      type: "column",
      responsive: false,
      //marginRight: 15,
      // marginTop: 3,
      height: 240,
      plotBorderWidth: 1,
      events: {
            render: function () {
            applyAccessibility(this);
            },
            redraw: function () {
            applyAccessibility(this);
            }
      }
    },
    title: null,
    legend: {
      enabled: false,
      // align: "center",
      // verticalAlign: "bottom",
      // layout: 'horizontal',
      // floating: true,
      // visible: true,
      // y: -10,
    },
    xAxis: {
      /*min: 0,
      max: 25,*/
      categories: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      startOnTick: true,
      title: {
        text: "Task",
        style: {
          fontWeight: 'bold',
          fontSize: '13px',
          color: "#000"
        },
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }
    },
    yAxis: { // Secondary yAxis
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 4,
      startOnTick: true,
      tickLength: 10,
      tickWidth: 1,
      tickColor: '#C6C6C3',
      color: 'rgb(255,255,255)',
      gridLineWidth: 0,
      title: {
        text: "Days",
        style: {
          fontWeight: 'bold',
          fontSize: '13px',
          color: "#000"
        }
      },
    },
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        const dayLabel = (point.y <= 1) ? 'day' : 'days';
        return `${point.category}: ${(simObj?.tasksInformation != undefined) ? simObj?.tasksInformation?.filter((item, index) => index == point.index)[0]?.taskName : ``}; ${(point.y != undefined) ? `${point.series.name.replace("Task ", "")}: ${point.y} ${dayLabel}` : ``}; ${(prevDataRef.current != undefined) ? `Task Status: ${prevDataRef.current?.filter((item, index) => index == point.index)[0]?.currentState}` : ``}; `;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Expected Task Time",
        borderWidth: 1,
        borderRadius: 0,
        states: {
          hover: {
            borderWidth: 1, // Border width on hover
            borderColor: 'black' // Border color on hover
          }
        },
        data: [],
        color: {
          pattern: {
            path: 'M 0 10 L 10 0',
            width: 10,
            height: 10,
            color: '#FFFFFF',
            backgroundColor: "#D93300"
  
          }
        },
      },
      {
        name: "Actual Task Time",
        borderWidth: 1,
        borderRadius: 0,
        crisp: true,
        states: {
          hover: {
            borderWidth: 1, // Border width on hover
            borderColor: 'black' // Border color on hover
          }
        },
        data: [],
        color: {
          pattern: {
            path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
            width: 10,
            height: 10,
            color: '#FFFFFF',
            backgroundColor: '#005A70'
          },
        }
      }
    ],
    tooltip: {
      hideDelay: 0,
      shared: true,
      crosshairs: true,
      borderWidth: 1,
      //backgroundColor: '#F8F8F8',
      style: {
        borderColor: function () {
          return this.point.color; // Set the tooltip box border color to match the point color
        },
        opacity: 0.9,
        fontSize: '14px',
      },
      formatter: function () {
        return '<strong style="font-size:12px">' + (this.point.category) + ': ' + simObj?.tasksInformation?.filter((item, index) => index == this.point.index)[0]?.taskName + '</strong><br/>' +
          this.points.map(point => {
            const dayLabel = (point.y <= 1) ? 'day' : 'days';
            return '<span style="font-weight:bold;font-size:12px;color:' + (point.series.name === "Expected Task Time" ? "#D93300" : point.series.name === "Actual Task Time" ? "#005A70" : "" ) + ';padding:0">' + point.series.name.replace("Task ", "") + '</span>: <strong style="font-size:12px;">' + point.y + ' ' + `${dayLabel}` + '</strong>';
          }).join('<br>') + '<br><span style="font-weight:bold;font-size:12px;padding:0">' + `Task Status: ` + prevDataRef.current?.filter((item, index) => index == this.point.index)[0]?.currentState + '</span>';
      }
      /*borderWidth: 1,
      formatter: function () {
        var tooltipText = '<strong>' + (this.point.date) + '</strong><br/>';
        if (this.series.name === 'Regular - Tracking Signal') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + this.y +'%' + '</strong>';
        } else if (this.series.name === 'Midgrade - Tracking Signal') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + this.y +'%' + '</strong>';
        } else if (this.series.name === 'Premium - Tracking Signal') {
          tooltipText += '<span style="color:' + this.point.color + ';">● </span>' + this.series.name + ': <strong style="font-weight: bold;">' + this.y +'%' + '</strong>';
        }
        return tooltipText;
      }*/
    }

  }

  useEffect(() => {
    // Save the current data to prevDataRef
    prevDataRef.current = seriesStatus;
  }, [seriesStatus]);

  useEffect(() => {
    const newChart = Highcharts.chart("TaskTime", graphSettings);
    setChart(newChart);
    // if (type === "monthly" || type === "quarterly" || type === "yearly") {
    //   const g_container = PmModuleStyle['graph-container'];
    //   let gContainer = document.getElementsByClassName(`${g_container}`)[1];
    //   gContainer.setAttribute("tabindex", '-1');
    //   gContainer.focus();
    // }
    //Added for xaxis type quarterly resizable.
  }, [type, tasksInfo]);

  useEffect(() => {
    if (tasksInfo.length == 0 && simObj?.tasksInformation) {
      setTasksInfo(simObj?.tasksInformation)
    }
  }, [simObj?.tasksInformation]);

  useEffect(() => {
    if (isResult && chart != undefined) {
      chart && chart.series && chart?.series[0]?.setData([]);
      chart && chart.series && chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      setGraphData();
    }
    if (chart != undefined) {
      setTasktimeGraphLabel(`Expected Time and Actual Time graphs representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval} per unit scale.`);
      document.querySelector("#TaskTime").setAttribute('role', `figure`);
      document.querySelector("#TaskTime .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata, summaryGraphData,simObjCopy,summaryReports]);
  useEffect(() => {
    if (isResult) {
      setGraphData();
    }
  }, [simObj, isResult, summaryGraphData,simObjCopy,summaryReports])


  return (
    <div className={`${PmModuleStyle['graph-container']}`}>
      {/* {!simObj?.graphdata?.length && <div className={`${PmModuleStyle['nodata-alert-TrackingSignal']}`}>Tracking Signal will appear here as the simulation runs</div>} */}
      <span></span>
      {/* <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost of Quality" className="sr-only"></a> */}
      <div id="TaskTime" className={`${PmModuleStyle['revenue-graph']}`} aria-label={TasktimeGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default TasktimeGraph